import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { PoFieldModule, PoI18nConfig, PoI18nModule, PoModalModule } from '@po-ui/ng-components';
import { PoStorageModule } from '@po-ui/ng-storage';
import { PoSyncModule } from '@po-ui/ng-sync';
import {
  MingleHttpInterceptor, MingleService
} from '@totvs/mingle';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppinitService } from './appinit.service';
import { LoginModule } from './core/home/login/login.module';
import { generalRU } from './i18n/general-RuRU';
import { generalEn } from './i18n/general-en';
import { generalEs } from './i18n/general-es';
import { generalPt } from './i18n/general-pt';
import { PGVInterceptor } from './shared/interceptors/pgv-interceptor.interceptors';

const i18nConfig: PoI18nConfig = {
  default: {
    language: navigator.language,
    context: 'general',
    cache: true
  },
  contexts: {
    general: {
      'pt-BR': generalPt,
      'en-US': generalEn,
      'es-ES': generalEs,
      'ru-RU': generalRU
    }
  }
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LoginModule,
    PoModalModule,
    PoFieldModule,
    ReactiveFormsModule,
    RouterModule.forRoot([], {}),
    PoI18nModule.config(i18nConfig),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    PoStorageModule.forRoot({
      name: 'storagetgv',
      storeName: '_storagetgv',
      driverOrder: ['lokijs', 'indexeddb', 'localstorage', 'websql']
    }),
    PoSyncModule
  ],
  providers: [
    AppinitService,
    MingleService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => inject(AppinitService).mingleConfiguration()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MingleHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PGVInterceptor,
      multi: true
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
    //{ provide: ErrorHandler, useClass: PoUIErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
